import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects'
import { push } from 'react-router-redux'
import {
  deleteScene,
  deleteSlate,
  deleteTake,
  getScenes,
  getSlates,
  getTakes,
  newScene,
  newSlate,
  newTake,
  saveScene,
  saveSlate,
  saveTake
} from '../services/pseudoApi/script'
import {
  fetchCreateSceneSuccess,
  fetchCreateSlateSuccess,
  fetchCreateTakeSuccess,
  fetchDeleteSceneSuccess,
  fetchDeleteSlateSuccess,
  fetchDeleteTakeSuccess,
  fetchScriptSuccess,
  fetchSaveSceneSuccess,
  fetchSaveSlateSuccess,
  fetchSaveTakeSuccess
} from '../actions/Script'
import {
  FETCH_CREATE_SCENE,
  FETCH_CREATE_SLATE,
  FETCH_CREATE_TAKE,
  FETCH_DELETE_SCENE,
  FETCH_DELETE_SLATE,
  FETCH_DELETE_TAKE,
  FETCH_SCRIPT,
  FETCH_SAVE_SCENE,
  FETCH_SAVE_SLATE,
  FETCH_SAVE_TAKE
} from '../constants/ActionTypes'

const getSceneFromState = ({script}, id) => script.scenes.byId[id]
const getSlateFromState = ({script}, id) => script.slates.byId[id]
const getTakeFromState = ({script}, id) => script.takes.byId[id]

// Fetch Script

export function* tryGetScript () {
  try {
    const fetchedScenes = yield call(getScenes)
    const fetchedSlates = yield call(getSlates)
    const fetchedTakes = yield call(getTakes)

    yield put(fetchScriptSuccess(fetchedScenes, fetchedSlates, fetchedTakes))
  } catch (error) {

  }
}

export function* watchFetchScript () {
  yield takeEvery(FETCH_SCRIPT, tryGetScript)
}

// Fetch Create Scene

export function* tryCreateScene () {
  try {
    const fetchedScene = yield call(newScene)

    yield put(fetchCreateSceneSuccess(fetchedScene, 'Scene has been added'))
    yield put(push(`/script-log/write/${fetchedScene.id}`))
  } catch (error) {

  }
}

export function* watchFetchCreateScene () {
  yield takeEvery(FETCH_CREATE_SCENE, tryCreateScene)
}

// Fetch Create Slate

export function* tryCreateSlate ({payload}) {
  try {
    const {sceneId} = payload
    const fetchedSlate = yield call(newSlate, sceneId)

    yield put(fetchCreateSlateSuccess(sceneId, fetchedSlate, 'Slate has been added'))
    yield put(push(`/script-log/write/${sceneId}/${fetchedSlate.id}`))
  } catch (error) {

  }
}

export function* watchFetchCreateSlate () {
  yield takeEvery(FETCH_CREATE_SLATE, tryCreateSlate)
}

// Fetch Create Take

export function* tryCreateTake ({payload}) {
  try {
    const {sceneId, slateId} = payload
    const fetchedTake = yield call(newTake, slateId)

    yield put(fetchCreateTakeSuccess(slateId, fetchedTake, 'Take has been added'))
    yield put(push(`/script-log/write/${sceneId}/${slateId}/${fetchedTake.id}`))
  } catch (error) {

  }
}

export function* watchFetchCreateTake () {
  yield takeEvery(FETCH_CREATE_TAKE, tryCreateTake)
}

// Fetch Update Scene

export function* trySaveScene ({payload}) {
  try {
    const {id} = payload
    const entryFromState = yield select(getSceneFromState, id)

    yield call(saveScene, id, entryFromState)

    yield put(fetchSaveSceneSuccess(id, 'Scene has been updated'))
  } catch (error) {

  }
}

export function* watchFetchSaveScene () {
  yield takeEvery(FETCH_SAVE_SCENE, trySaveScene)
}

// Fetch Update Slate

export function* trySaveSlate ({payload}) {
  try {
    const {id} = payload
    const entryFromState = yield select(getSlateFromState, id)

    yield call(saveSlate, id, entryFromState)

    yield put(fetchSaveSlateSuccess(id, 'Slate has been updated'))
  } catch (error) {

  }
}

export function* watchFetchSaveSlate () {
  yield takeEvery(FETCH_SAVE_SLATE, trySaveSlate)
}

// Fetch Update Take

export function* trySaveTake ({payload}) {
  try {
    const {id} = payload
    const entryFromState = yield select(getTakeFromState, id)

    yield call(saveTake, id, entryFromState)

    yield put(fetchSaveTakeSuccess(id, 'Take has been updated'))
  } catch (error) {

  }
}

export function* watchFetchSaveTake () {
  yield takeEvery(FETCH_SAVE_TAKE, trySaveTake)
}

// Fetch Delete Scene

export function* tryDeleteScene ({payload}) {
  try {
    const {id} = payload
    yield call(deleteScene, id)

    yield put(fetchDeleteSceneSuccess(id, 'Scene has been deleted'))
  } catch (error) {

  }
}

export function* watchFetchDeleteScene () {
  yield takeEvery(FETCH_DELETE_SCENE, tryDeleteScene)
}

// Fetch Delete Slate

export function* tryDeleteSlate ({payload}) {
  try {
    const {id, sceneId} = payload
    yield call(deleteSlate, id, sceneId)

    yield put(fetchDeleteSlateSuccess(id, sceneId, 'Slate has been deleted'))
  } catch (error) {

  }
}

export function* watchFetchDeleteSlate () {
  yield takeEvery(FETCH_DELETE_SLATE, tryDeleteSlate)
}

// Fetch Delete Scene

export function* tryDeleteTake ({payload}) {
  try {
    const {id, slateId} = payload
    yield call(deleteTake, id, slateId)

    yield put(fetchDeleteTakeSuccess(id, slateId, 'Take has been deleted'))
  } catch (error) {

  }
}

export function* watchFetchDeleteTake () {
  yield takeEvery(FETCH_DELETE_TAKE, tryDeleteTake)
}

// Root

export default function* rootSaga () {
  yield all([
    fork(watchFetchScript),
    fork(watchFetchCreateScene),
    fork(watchFetchCreateSlate),
    fork(watchFetchCreateTake),
    fork(watchFetchSaveScene),
    fork(watchFetchSaveSlate),
    fork(watchFetchSaveTake),
    fork(watchFetchDeleteScene),
    fork(watchFetchDeleteSlate),
    fork(watchFetchDeleteTake)
  ])
}


// WEBPACK FOOTER //
// ./sagas/Script.js